<template>
  <div class="logo-what-not-2-content" id="identidade-visual-logo-o-que-nao-fazer-cont" data-search-anchor>    
    <div class="description-what-not-2-wrapper">
      <div class="icon-wrapper">
        <IconCancel />
        <p class="logo-what-not-2-description">{{ logoWhatNotToDo2Description }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCancel />
        <p class="logo-what-not-2-description">{{ logoWhatNotToDo2Description1 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCancel />
        <p class="logo-what-not-2-description">{{ logoWhatNotToDo2Description2 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCancel />
        <p class="logo-what-not-2-description">{{ logoWhatNotToDo2Description3 }}</p>
      </div>
    </div>
    <div
      class="logo-what-not-2-card-item"
      :style="{ backgroundImage: `url(${logoSignature4BrandsImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCancel from '@/assets/icons/IconCancel.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCancel } })
export default class LogoWhatNotToDoSection2 extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoWhatNotToDo2Description(): string {
    return this.getElementText(21, 0)
  }

  get logoWhatNotToDo2Description1(): string {
    return this.getElementText(21, 1)
  }

  get logoWhatNotToDo2Description2(): string {
    return this.getElementText(21, 2)
  }

  get logoWhatNotToDo2Description3(): string {
    return this.getElementText(21, 3)
  }

  get logoSignature4BrandsImageSrc(): string {
    return this.getElementMedia(21, 4)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-what-not-2-content {
  width: 100%;
  display: grid;
  max-width: 1032px;
}

.title-signature-brands-wrapper {
  display: flex;
  align-items: center;
  padding: 3rem;
}

.logo-what-not-2-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}
.logo-what-not-2-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-what-not-2-wrapper {  
  position: relative;
  align-items: flex-start;  

  display: grid;
  grid-template-columns: 51.2% 48.8%; 
  margin-top: 2rem; 
}

.logo-what-not-2-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px;
}

.logo-what-not-2-card-item {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain; 
  margin-bottom: 2rem;
}
</style>
